import type { TagProps } from "@wayflyer/flyui";

import type { PlatformConnection } from "./platform-connection-list";

export type LegacyTag =
  | "notconnected"
  | "disconnected"
  | "connected"
  | "paid"
  | "active"
  | "paused"
  | "green"
  | "red"
  | "purple"
  | "orange";

const badgeStatusMap: Record<LegacyTag, TagProps["color"]> = {
  notconnected: undefined,
  disconnected: "critical",
  connected: "positive",
  paid: undefined,
  active: "positive",
  paused: "warning",
  green: "positive",
  red: "critical",
  purple: undefined,
  orange: "warning",
};

export const getBadgeStatus = (connection: PlatformConnection): TagProps["color"] => {
  if (connection.tagData?.type) {
    return badgeStatusMap[connection.tagData.type];
  }
  if (connection.tagData?.status) {
    const status = connection.tagData.status;
    if (status === "connected") {
      return "positive";
    }
    if (status === "expiringSoon") {
      return "warning";
    }
    return "critical";
  }
  return undefined;
};
